// extracted by mini-css-extract-plugin
export var container = "styles-module__container___tsIdl";
export var contentContainer = "styles-module__contentContainer___e5JKC";
export var heading = "styles-module__heading___m8oHw";
export var iconButton = "styles-module__iconButton___fAnhP";
export var logoContainer = "styles-module__logoContainer___EYZVV";
export var modalContainer = "styles-module__modalContainer___FDx6I";
export var modalLogo = "styles-module__modalLogo___mDyDU";
export var pressRelease = "styles-module__pressRelease___OTIeR";